<template>
  <div>
    <v-select v-model="paymentType"
              :options="$root.paymentTypes"
              :on-change="$emit('payment-type-change', {PaymentTypeId: paymentType.Id})"
              label="Name">
    </v-select>
  </div>
</template>

<script>
import { get } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/order-add-form`;

export default {
  props: ['paymentTypeId'],
  data() {
    return {
      paymentType: {},
    };
  },
  async beforeMount() {
    await this.fetchPaymentType();
  },
  watch: {
    async paymentTypeId(newVal) {
      console.log(newVal);
      if (newVal) {
        await this.fetchPaymentType();
      }
    },
  },
  methods: {
    async fetchPaymentType() {
      if (!this.paymentTypeId) return;
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/payment-type/${this.paymentTypeId}`);
      this.paymentType = data;
    },
    // onSearch(search, loading) {
    //   if (!search) {
    //     return;
    //   }
    //   loading(true);
    //   this.search(loading, search, this);
    // },
    // search: _.debounce((loading, search, vm) => {
    //   get(`${url}/search-customers?q=${(search)}`)
    //     .then((res) => {
    //       vm.customers = res.data;
    //       loading(false);
    //     });
    // }, 350),
  },
};
</script>
